import { createContext, useContext, useState, useEffect } from 'react';

const FormDataContext = createContext();

export const FormDataProvider = ({ children }) => {
  const [userData, setUserData] = useState(() => {
    // Load from localStorage initially
    const savedData = localStorage.getItem('userData');
    return savedData ? JSON.parse(savedData) : null;
  });

  // Save to localStorage whenever userData changes
  useEffect(() => {
    if (userData) {
      localStorage.setItem('userData', JSON.stringify(userData));
    }
  }, [userData]);

  return (
    <FormDataContext.Provider value={{ userData, setUserData }}>
      {children}
    </FormDataContext.Provider>
  );
};

export const useFormData = () => useContext(FormDataContext);
